import type { NFTTokenType, TokenType } from 'types/api/token';

import config from 'configs/app';

const tokenStandardName = config.chain.tokenStandard;

export const NFT_TOKEN_TYPES: Record<NFTTokenType, string > = {
  'ERC-721': 'QIE-721',
  'ERC-1155': 'QIE-1155',
  'ERC-404': 'QIE-404',
};

export const TOKEN_TYPES: Record<TokenType, string > = {
  'ERC-20': 'QIE-20',
  ...NFT_TOKEN_TYPES,
};

export const NFT_TOKEN_TYPE_IDS: Array<NFTTokenType> = [ 'ERC-721', 'ERC-1155', 'ERC-404' ];
export const TOKEN_TYPE_IDS: Array<TokenType> = [ 'ERC-20', ...NFT_TOKEN_TYPE_IDS ];

export function getTokenTypeName(typeId: TokenType) {
  const typeMap: Record<string, string> = {
    'ERC-20': 'QIE-20',
    'ERC-721': 'QIE-721',
    'ERC-1155': 'QIE-1155',
    'ERC-404': 'QIE-404',  // Keep this here if you want to support it
    // Add more if needed
  };

  return typeMap[typeId] ?? TOKEN_TYPES[typeId] ?? typeId;
}
